import React, { useEffect, useState } from "react";
import StatusTabCheckIn from "./StatusTabCheckIn";
import StatusTabArray from "./StatusTabArray";
import StatusTabStay from "./StatusTabStay";
import { useSelector } from "react-redux";
import { changeDataToDDMMYYYY, changeDataToYYYY_MMMM_DD } from '../../utils/Date/SupportDate';
import StatusTabArray2 from "./StatusTabArray2";
import './status.css';

function StatusTabGlist(props) {
    const { isFullWith, cssWithBranch, LANGUAGE } = props;
    // const [note, setNote] = useState("");
    //const [heightNote,setHeightNote] = useState("");
    const dataGlist = useSelector(state => state.glist);
    const dataBranchOnState = useSelector(state => state.dataPickUp.glist);
    // const [showType, setShowType] = useState("1tab");
    const auth = useSelector(state => state.auth);
    const [countGuestCheckIn, setCountGuestCheckIn] = useState(0);

    const { branchID } = auth.user;

    const stayRoomSet = new Set(
        String(dataGlist.listGuestStay || "")
            .split(",")
            .map(room => room.trim())
            .filter(Boolean)
    );
    const stayRoomNights = {};
    if (branchID === 16 && Array.isArray(dataGlist.content)) {
        dataGlist.content.forEach(room => {
            const roomNumber = String(room.roomNumber);
            if (!stayRoomSet.has(roomNumber) || !room.checkIn) return;

            const checkInDate = new Date(room.checkIn);
            const selectedDate = new Date(dataBranchOnState.day);
            if (Number.isNaN(checkInDate.getTime()) || Number.isNaN(selectedDate.getTime())) return;

            const checkInDay = Date.UTC(checkInDate.getFullYear(), checkInDate.getMonth(), checkInDate.getDate());
            const selectedDay = Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate());
            const nightsStayed = Math.round((selectedDay - checkInDay) / (24 * 60 * 60 * 1000)) + 1;

            stayRoomNights[roomNumber] = nightsStayed;
        });
    }

    useEffect(() => {
        var textarea = document.getElementById("YourTextArea");
        var limit = 100; //height limit

        textarea.oninput = function () {
            textarea.style.height = "";
            textarea.style.height = Math.min(textarea.scrollHeight, limit) + "px";
        };
    }, [dataGlist.note]);

    useEffect(() => {
        if (branchID === 1 || branchID === 9) {
            const countSub1 = dataGlist.listGuestCheckInSub1.filter(item => (item.room !== "" && item.room !== " X")) 
            const countSub2 = dataGlist.listGuestCheckInSub2.filter(item => (item.room !== "" && item.room !== " X"))  
            const countSub3 = dataGlist.listGuestCheckInSub3.filter(item => (item.room !== "" && item.room !== " X"))  

                //+ dataGlist.listGuestCheckInSub2.filter(item => item.room !== "") + dataGlist.listGuestCheckInSub3.filter(item => item.room !== "");
            setCountGuestCheckIn(countSub1.length + countSub2.length + countSub3.length);
        }
    },[branchID, dataGlist.listGuestCheckInSub1, dataGlist.listGuestCheckInSub2, dataGlist.listGuestCheckInSub3])

    function updateStatusTabArray(target,value) {
        props.updateStatusTabArray(target,value);
    }

    return (<div className="d-flex" style={{width: isFullWith ? "100%" : '600px', marginBottom:'12px', }}>

        <div style={{ fontSize: '1.3rem', }}>
            <div style={{ 
                fontSize: '1.5rem', 
                fontWeight: '600', 
                border: '1px solid black', 
                textAlign: 'center' 
            }}
            className="d-flex">
                <div style={{margin:'auto', padding:'4px'}}>{branchID === 11 ? `STATUS ROOM ON ${changeDataToYYYY_MMMM_DD(dataBranchOnState.day)}`: `Tình Trạng Phòng ngày + ${changeDataToDDMMYYYY(dataBranchOnState.day)}`}
                <button className="btn btn-primary ml-2 no-print"
                       onClick={()=>props.onConfirmReload()}
                        >Reload</button>
                        </div>
            </div>
            <div className="d-flex">
                <StatusTabCheckIn 
                    target =   {(branchID === 9 || branchID === 1) ? "listGuestCheckInSub1" : "listGuestCheckIn"} 
                    LANGUAGE={LANGUAGE}
                    // showType = {showType}
                    // setShowType = {setShowType}
                    subNameTable = {branchID === 9 ? "29 Thai Van Lung" : branchID === 1 ? "Azumaya" : false }
                    cssWithBranch={cssWithBranch}
                    updateStatusTabArray={updateStatusTabArray}
                    branchID = {branchID}
                />

                {(branchID === 9 || branchID === 1) && <StatusTabCheckIn
                    target = "listGuestCheckInSub2"
                    // showType = {showType}
                    // setShowType = {setShowType}
                    subNameTable = {branchID === 9 ? "27 Thai Van Lung" : branchID === 1 ? "Ngoc Anh" : false }
                    cssWithBranch={cssWithBranch}
                    updateStatusTabArray={updateStatusTabArray}
                    branchID = {branchID}
                />}

                {( branchID === 1) && <StatusTabCheckIn 
                    target = "listGuestCheckInSub3"
                    // showType = {showType}
                    // setShowType = {setShowType}
                    subNameTable = {branchID === 1 && "Annex" }
                    cssWithBranch={cssWithBranch}
                    updateStatusTabArray={updateStatusTabArray}
                    branchID = {branchID}
                />}
            </div>

            <div style={{ textAlign: 'left', fontWeight: '600', fontSize: '1.3rem', border: '1px solid black' }}>
                <label className="ml-3 mr-3">{branchID === 11 ? "Total" : "Tổng:"}</label>
                <input 
                    style={{ width: '50px', border: '0px solid black', marginLeft: '8px', fontSize: '1.5rem',}} 
                    value = {countGuestCheckIn}
                    maxLength="2"></input>
            </div>

            <StatusTabArray
                title={branchID === 11 ? "CHECK OUT":"PHÒNG CHECK OUT"}
                isFullWith={isFullWith}
                data = {dataGlist.listGuestCheckOut}
                target = "listGuestCheckOut"
                cssWithBranch={cssWithBranch}
                height={(branchID === 8 || branchID === 9 || branchID === 4 || branchID === 1)  ? "100px" : "unset"}
                updateStatusTabArray={updateStatusTabArray}
                branchID = {branchID}
            />
            {<StatusTabArray
                title={branchID === 11 ? "CHECK OUT NEXT DAY":"PHÒNG CHECK OUT HOM SAU"}
                isFullWith={isFullWith}
                data={dataGlist.listGuestCheckOutNextDay}
                target = "listGuestCheckOutNextDay"
                cssWithBranch={cssWithBranch}
                height={(branchID === 8 || branchID === 9 || branchID === 4 || branchID === 1) ? "100px" : "unset"}
                updateStatusTabArray={updateStatusTabArray}
                branchID = {branchID}
            />}
            {branchID === 99 ? (
                <StatusTabStay
                    title="PHÒNG Ở"
                    isFullWith={isFullWith}
                    data={dataGlist.listGuestStay}
                    height="150px"
                    roomNights={stayRoomNights}
                    checkOutNextDay={dataGlist.listGuestCheckOutNextDay}
                    updateStatusTabArray={updateStatusTabArray}
                />
            ) : (
                <StatusTabArray
                    title={branchID === 11 ? "STAY ROOM" : "PHÒNG Ở"}
                    isFullWith={isFullWith}
                    data={dataGlist.listGuestStay}
                    target="listGuestStay"
                    cssWithBranch={cssWithBranch}
                    height={(branchID === 8 || branchID === 9 || branchID === 4 || branchID === 1 || branchID === 11) ? "150px" : "unset"}
                    updateStatusTabArray={updateStatusTabArray}
                    branchID={branchID}
                />
            )}
            {
                branchID === 11 &&   <StatusTabArray
                                title={branchID === 11 ? "PREPARE ROOM": "PHÒNG SẠCH"}
                                isFullWith={isFullWith}
                                data = {dataGlist.listCleanRoom}
                                target = "listCleanRoom"
                                cssWithBranch={cssWithBranch}
                                height={(branchID === 8 ) ? "150px" : "unset"}
                                updateStatusTabArray={updateStatusTabArray}
                                branchID = {branchID}
                            />
            }
            {
                (branchID === 7 || branchID === 13) && <>
                            <StatusTabArray2
                                title={branchID === 11 ? "DIRTY ROOM":"PHÒNG BẨN"}
                                isFullWith={isFullWith}
                                data = {dataGlist.listDirtyRoom}
                                target = "listDirtyRoom"
                                cssWithBranch={cssWithBranch}
                                height={branchID === 8 ? "150px" : "unset"}
                                updateStatusTabArray={updateStatusTabArray}
                                branchID = {branchID}
                            />
                            <StatusTabArray2
                                title={branchID === 11 ? "CLEAN ROOM": "PHÒNG SẠCH"}
                                isFullWith={isFullWith}
                                data = {dataGlist.listCleanRoom}
                                target = "listCleanRoom"
                                cssWithBranch={cssWithBranch}
                                height={(branchID === 8 ) ? "150px" : "unset"}
                                updateStatusTabArray={updateStatusTabArray}
                                branchID = {branchID}
                            />
                            <StatusTabArray2
                                title={branchID === 11 ? "MAINTEN ROOM": "PHÒNG BẢO TRÌ"}
                                isFullWith={isFullWith}
                                data = {dataGlist.listLockRoom}
                                target = "listLockRoom"
                                cssWithBranch={cssWithBranch}
                                height={branchID === 8 ? "150px" : "unset"}
                                updateStatusTabArray={updateStatusTabArray}
                                branchID = {branchID}
                            />
                </>
            }

            <div className="d-flex mb-5" style={{
                border: '1px solid black',
                fontSize: '2rem',
                fontWeight: '600',
            }}>
            <div style={{ margin: 'auto', padding: '2px' }}> Note</div>
                <textarea
                    id="YourTextArea"
                    value={dataGlist.note}
                    onChange={e => updateStatusTabArray("note", e.target.value)}
                    style={{ 
                        fontSize: branchID === 3 ? '2rem' : '1.4rem',
                        width: '100%', 
                        padding: '4px',
                        height:'auto',
                        minHeight:'auto',
                        maxHeight:'auto'
                        }}>
                </textarea>
            </div >
            {/* Note old */}
            <div className="d-flex mb-5 no-print" >
                <div style={{ margin: 'auto', padding: '2px', width:'50px', fontSize:'1.5rem', border:'1px solid'}} className="no-print"> Note Old Date</div>
                <textarea
                        id="YourTextArea"
                        value={dataGlist.noteOld}
                        className="no-print"
                        onChange={e => updateStatusTabArray("note", e.target.value)}
                        disabled
                        style={{ 
                            fontSize: branchID === 3 ? '2rem' : '1.4rem',
                            border:'1px solid',
                            width: '100%', 
                            padding: '4px',
                            height:'auto',
                            minHeight:'auto',
                            maxHeight:'auto'
                            }}>
                    </textarea>
            </div >
        </div >
    </div>)
}

export default StatusTabGlist;
